import { useCallback, useMemo } from 'react';

import type { FilterProps, SetFiltersProps } from './use-api-controller';

export interface DataTableFacetedFilterProps {
  column: string;
  title?: string;
  curFilter: FilterProps;
  setFilters?: SetFiltersProps;
  options: {
    name: string;
    value: string;
    icon?: React.ComponentType<{ className?: string }>;
  }[];
}

export function useFacetedFilter({ curFilter, column, setFilters }: DataTableFacetedFilterProps) {
  const handleSelectedChange = useCallback(
    (newValue: string[]) => {
      if (setFilters) {
        setTimeout(() => {
          setFilters({ name: column, value: newValue });
        }, 0);
      }
    },
    [setFilters, column]
  );

  const selected = useMemo(
    () =>
      curFilter.reduce((items, item) => {
        if (item.name === column) {
          items.push(...item.value);
        }
        return items;
      }, [] as string[]),
    [column, curFilter]
  );

  const selectedValues = new Set(selected);
  return { isFiltered: selected.length >= 0, selectedValues, setSelected: handleSelectedChange };
}
